/**
 * Bucket returned by the drill down for vehicles without a value of the level (e.g. unknown seat count).
 */
export const OTHER_LEVEL_VALUE = 'other';
